module.exports = __webpack_public_path__ + "static/media/buoy.a3e367a8.png";